import { render, staticRenderFns } from "./cardProductoCarrito.vue?vue&type=template&id=08244bef&scoped=true&"
import script from "./cardProductoCarrito.vue?vue&type=script&lang=js&"
export * from "./cardProductoCarrito.vue?vue&type=script&lang=js&"
import style0 from "./cardProductoCarrito.vue?vue&type=style&index=0&id=08244bef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08244bef",
  null
  
)

export default component.exports